import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { BinaryExpression } from "../expressions/BinaryExpression";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJToken } from "../expressions/RJToken";
import { RJParserMessages } from "../parsers/RJParserMessages";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";
import { Operator } from "./Operator";

export class BinaryOperator extends Operator
{
  _symbol:string;
  _fromLeft:boolean;

  constructor( parser:RJParser, symbol:string, fromLeft:boolean = true )
  {
    super( parser );
    this.setStartToken( RJLexer.OperatorMatcher.type, symbol );
    this._symbol = symbol;
    this._fromLeft = fromLeft;
  }

  public isFromLeft():boolean
  {
    return this._fromLeft;
  }

  public processStartNode( nodes:RJExpressionNode[], index:number )
  {
    //var messages = UniqueSO<MathExpressionMessages>.Get();
    var node = nodes[ index ] as any as RJToken;
    
    if ( index == 0 || index + 1 >= nodes.length )
    {
      if ( index == 0 )
      {
        this.processor.parser.error( RJParserMessages.missingLeftArgument, node.sourceInfo );
      }

      if ( index + 1 >= nodes.length )
      {
        this.processor.parser.error( RJParserMessages.missingRightArgument, node.sourceInfo );
      }
      
      return false;
    }

    var binary = new BinaryExpression( this._parser, SourceRange.combine( nodes[ index - 1 ].sourceRange, nodes[ index + 1 ].sourceRange ) );
    binary.setBinary( node, nodes[ index - 1 ], nodes[ index + 1 ] );

    console.log( "Nodes before", nodes.map( n => n.typeString ).join( "," ));
    RJExpressionNode.replaceRange( nodes, index - 1, 3, binary );

    console.log( "Nodes after", nodes.map( n => n.typeString ).join( "," ));

    //BPOLog.Log( "Created binary:", node.value );

    return true;
  }
}
